angular.module('bmsApp.settings').factory('MailchimpCampaignSvc', function ($http, $log, $window, $q, CRUDSvc) {
    var baseUrl = 'api/mailchimpCampaign/';
	return {
		save: function(params) {return CRUDSvc.post(baseUrl + 'save', params);},
}});